import type { Vector3 } from "../simulation/types";
import { EARTH_RADIUS } from "../simulation/constants";

export interface TourPose {
  readonly position: Vector3;
  readonly target: Vector3;
}

export interface TourStep {
  readonly caption: string;
  getPose(moonPosition: Vector3): TourPose;
}

export const TOUR_STEPS: readonly TourStep[] = [
  {
    caption:
      "Step 1 of 3 — The Sun shines from one direction, like a lamp across the room. Its light travels in parallel rays past Earth and Moon.",
    getPose: () => ({ position: [-4, 5, 17], target: [-4, 0, 0] }),
  },
  {
    caption:
      "Step 2 of 3 — Half of the Moon is always lit: the half facing the Sun. Watch the day–night boundary as it orbits.",
    getPose: (moonPosition) => ({
      position: [
        moonPosition[0] - 2.4,
        moonPosition[1] + 1.6,
        moonPosition[2] + 3.4,
      ],
      target: moonPosition,
    }),
  },
  {
    caption:
      "Step 3 of 3 — From Earth we only see part of that lit half. The visible slice is the phase — try standing here yourself.",
    getPose: (moonPosition) => {
      const length = Math.hypot(...moonPosition) || 1;
      const towardMoon = moonPosition.map(
        (component) => component / length,
      ) as unknown as Vector3;
      return {
        position: [
          towardMoon[0] * (EARTH_RADIUS + 1.4),
          towardMoon[1] * (EARTH_RADIUS + 1.4) + 1,
          towardMoon[2] * (EARTH_RADIUS + 1.4),
        ],
        target: moonPosition,
      };
    },
  },
];

export function getTourPose(
  stepIndex: number,
  moonPosition: Vector3,
): TourPose | null {
  return TOUR_STEPS[stepIndex]?.getPose(moonPosition) ?? null;
}
